(() => {
  'use strict';

  const link = document.querySelector('.mp-whatsapp-flotante');
  if (!link || link.dataset.positionReady) return;
  link.dataset.positionReady = 'true';

  // La compra en la ficha también puede pasar por la esquina inferior al hacer scroll.
  // Ocultamos WhatsApp mientras haya un control de compra visible en móvil/tablet.
  const visibleControls = new Set();
  const controls = new Set();
  const observer = new IntersectionObserver((entries) => {
    for (const entry of entries) {
      if (entry.isIntersecting) visibleControls.add(entry.target);
      else visibleControls.delete(entry.target);
    }
    document.body.classList.toggle('mp-whatsapp-purchase-visible', visibleControls.size > 0);
  });

  const refresh = () => {
    for (const control of controls) {
      if (!control.isConnected) {
        observer.unobserve(control);
        controls.delete(control);
        visibleControls.delete(control);
      }
    }
    for (const control of document.querySelectorAll('buy-buttons, flooring-calculator')) {
      if (controls.has(control)) continue;
      controls.add(control);
      observer.observe(control);
    }
    document.body.classList.toggle('mp-whatsapp-purchase-visible', visibleControls.size > 0);
  };

  // product-rerender sustituye los controles al cambiar de variante.
  let frame;
  new MutationObserver(() => {
    if (frame) return;
    frame = requestAnimationFrame(() => {
      frame = 0;
      refresh();
    });
  }).observe(document.querySelector('#main') || document.body, { childList: true, subtree: true });
  refresh();
})();
